import { getFiltersMap } from '../../../../Components/ReactDataGrid/SortFilterTables';

type FilterItem = {
  name: string;
  value: any;
  operator?: 'equals' | 'gt' | 'lt' | 'between' | 'gte' | 'lte' | 'eq';
};

export function buildFiltersObject(filterArray: FilterItem[]) {
  const filtersMap = getFiltersMap();
  const filtersObj: Record<string, any> = {};

  filterArray.forEach(({ name, value, operator }) => {
    if (value === '' || value === null || value === undefined) return;

    const paramName = filtersMap.has(name) ? filtersMap.get(name) : name;
    filtersObj[paramName] = value;

    if (typeof value === 'number' || (!isNaN(value) && value !== '')) {
      const numValue = typeof value === 'number' ? value : parseFloat(value);

      switch (operator) {
        case 'equals':
          if (paramName.toLowerCase().includes('year')) {
            filtersObj[`min_${paramName}`] = numValue;
            filtersObj[`max_${paramName}`] = numValue;
          } else {
            filtersObj[`min_${paramName}`] = numValue - 0.05;
            filtersObj[`max_${paramName}`] = numValue + 0.05;
          }
          break;

        case 'eq':
          if (paramName.toLowerCase().includes('year')) {
            filtersObj[`min_${paramName}`] = numValue;
            filtersObj[`max_${paramName}`] = numValue;
          } else if (paramName.toLowerCase().includes('score') || paramName.toLowerCase().includes('ei')) {
            filtersObj[`min_${paramName}`] = numValue - 0.005;
            filtersObj[`max_${paramName}`] = numValue + 0.005;
          } else {
            filtersObj[`min_${paramName}`] = numValue - 0.05;
            filtersObj[`max_${paramName}`] = numValue + 0.05;
          }
          break;

        case 'gt':
          if (paramName.toLowerCase().includes('score') || paramName.toLowerCase().includes('ei')) {
            filtersObj[`min_${paramName}`] = numValue + 0.005;
          } else {
            filtersObj[`min_${paramName}`] = numValue + 1;
          }
          break;

        case 'lt':
          if (
            paramName.toLowerCase().includes('score') ||
            paramName.toLowerCase().includes('ei') ||
            paramName.toLowerCase().includes('dsi') ||
            paramName.toLowerCase().includes('dpi') ||
            paramName.toLowerCase().includes('pli') ||
            paramName.toLowerCase().includes('sokal')
          ) {
            filtersObj[`max_${paramName}`] = numValue - 0.005;
          } else {
            filtersObj[`max_${paramName}`] = numValue - 1;
          }
          break;

        case 'between':
          if (Array.isArray(value) && value.length === 2) {
            filtersObj[`min_${paramName}`] = parseFloat(value[0]);
            filtersObj[`max_${paramName}`] = parseFloat(value[1]);
          }
          break;
        case 'gte':
          filtersObj[`min_${paramName}`] = numValue;
          break;
        case 'lte':
          filtersObj[`max_${paramName}`] = numValue;
          break;
        default:
          if (
            paramName.includes('year') ||
            paramName.includes('Year') ||
            paramName.includes('numPMIDsupportingAssociation')
          ) {
            filtersObj[`min_${paramName}`] = numValue;
            filtersObj[`max_${paramName}`] = numValue;
          } else {
            filtersObj[`min_${paramName}`] = numValue - 0.05;
            filtersObj[`max_${paramName}`] = numValue + 0.05;
          }
      }
    }
  });

  return filtersObj;
}
